import { render, staticRenderFns } from "./SocialUploadModal.vue?vue&type=template&id=33e2113b&scoped=true"
import script from "./SocialUploadModal.vue?vue&type=script&lang=js"
export * from "./SocialUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2113b",
  null
  
)

export default component.exports